import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { productionService, ProductionPage } from './production-service'
import { toast } from 'sonner'

export function useProduction() {
    const queryClient = useQueryClient()

    const { data: production, isLoading } = useQuery({
        queryKey: ['production'],
        queryFn: productionService.getProductionPage,
    })

    const updateProductionMutation = useMutation({
        mutationFn: ({ data, translate }: { data: Partial<ProductionPage>, translate?: boolean }) =>
            productionService.updateProductionPage(data, translate),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['production'] })
            toast.success('Üretim süreci başarıyla güncellendi.')
        },
        onError: (err: any) => {
            toast.error(err.response?.data?.message || 'Güncelleme sırasında bir hata oluştu.')
        },
    })

    const updateProduction = async ({ data, translate }: { data: Partial<ProductionPage>, translate?: boolean }) => {
        return await updateProductionMutation.mutateAsync({ data, translate });
    };

    return {
        production,
        isLoading,
        updateProduction,
        isUpdating: updateProductionMutation.isPending
    };
}
